// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.sidebar {
    position: absolute;
    top: var(--topbar-height);
    max-height: calc(100vh - var(--topbar-height) - var(--bottombar-height));
    max-height: calc(var(--vh, 1vh) * 100 - var(--topbar-height) - var(--bottombar-height));
    background-color: var(--container-bg-color);
    transition: transform 0.25s;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.75);
    display: flex;
    flex-direction: column;
    max-width: 100vw;
}

div.sidebar-right {
    right: 0;
}

div.sidebar-left {
    left: 0;
}

div.sidebar-right:not(.sidebar-open) {
    transform: translateX(100%) translateX(8px);
}

div.sidebar-left:not(.sidebar-open) {
    transform: translateX(-100%) translateX(-8px);
}

div.sidebar-resize-handle {
    position: absolute;
    width: 6px;
    top: 0;
    bottom: 0;
    cursor: ew-resize;
    z-index: 2;
}

div.sidebar-resize-handle-left {
    right: -3px;
}

div.sidebar-resize-handle-right {
    left: -3px;
}

div.sidebar-resize-handle-bottom {
    position: absolute;
    height: 6px;
    left: 0;
    right: 0;
    bottom: -3px;
    cursor: ns-resize;
    z-index: 2;
}

div.sidebar div.sidebar-titlebar {
    color: var(--titlebar-text-color);
    background-color: var(--titlebar-bg-color);
    height: 2.5em;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
}

div.sidebar span.sidebar-titlebar-icon {
    flex: 0 0 auto;
    margin: 0 0.25em;
}

div.sidebar span.sidebar-titlebar-title {
    font-weight: bold;
    flex: 0 0 auto;
}

div.sidebar span.sidebar-titlebar-spacer {
    flex: 1 1 auto;
}

div.sidebar div.sidebar-titlebar span.sidebar-title {
    font-weight: bold;
    display: inline-flex;
    width: calc(100% - 3em);
    align-items: center;
}

div.sidebar span.sidebar-titlebar-closeicon {
    flex: 0 0 auto;
    margin: 0 0.25em;
    font-size: large;
}

div.sidebar div.sidebar-body {
    overflow-y: auto;
    overflow-x: hidden;
    /* titlebar: 2.5em */
    max-height: calc(100vh - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/
    max-height: calc(var(--vh, 1vh) * 100 - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/
    flex: 1 1 auto;
}
`, "",{"version":3,"sources":["webpack://./qwc2/components/style/SideBar.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,wEAAwE;IACxE,uFAAuF;IACvF,2CAA2C;IAC3C,2BAA2B;IAC3B,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,iCAAiC;IACjC,0CAA0C;IAC1C,aAAa;IACb,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,gFAAgF,EAAE,oDAAoD;IACtI,+FAA+F,EAAE,oDAAoD;IACrJ,cAAc;AAClB","sourcesContent":["div.sidebar {\n    position: absolute;\n    top: var(--topbar-height);\n    max-height: calc(100vh - var(--topbar-height) - var(--bottombar-height));\n    max-height: calc(var(--vh, 1vh) * 100 - var(--topbar-height) - var(--bottombar-height));\n    background-color: var(--container-bg-color);\n    transition: transform 0.25s;\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.75);\n    display: flex;\n    flex-direction: column;\n    max-width: 100vw;\n}\n\ndiv.sidebar-right {\n    right: 0;\n}\n\ndiv.sidebar-left {\n    left: 0;\n}\n\ndiv.sidebar-right:not(.sidebar-open) {\n    transform: translateX(100%) translateX(8px);\n}\n\ndiv.sidebar-left:not(.sidebar-open) {\n    transform: translateX(-100%) translateX(-8px);\n}\n\ndiv.sidebar-resize-handle {\n    position: absolute;\n    width: 6px;\n    top: 0;\n    bottom: 0;\n    cursor: ew-resize;\n    z-index: 2;\n}\n\ndiv.sidebar-resize-handle-left {\n    right: -3px;\n}\n\ndiv.sidebar-resize-handle-right {\n    left: -3px;\n}\n\ndiv.sidebar-resize-handle-bottom {\n    position: absolute;\n    height: 6px;\n    left: 0;\n    right: 0;\n    bottom: -3px;\n    cursor: ns-resize;\n    z-index: 2;\n}\n\ndiv.sidebar div.sidebar-titlebar {\n    color: var(--titlebar-text-color);\n    background-color: var(--titlebar-bg-color);\n    height: 2.5em;\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n}\n\ndiv.sidebar span.sidebar-titlebar-icon {\n    flex: 0 0 auto;\n    margin: 0 0.25em;\n}\n\ndiv.sidebar span.sidebar-titlebar-title {\n    font-weight: bold;\n    flex: 0 0 auto;\n}\n\ndiv.sidebar span.sidebar-titlebar-spacer {\n    flex: 1 1 auto;\n}\n\ndiv.sidebar div.sidebar-titlebar span.sidebar-title {\n    font-weight: bold;\n    display: inline-flex;\n    width: calc(100% - 3em);\n    align-items: center;\n}\n\ndiv.sidebar span.sidebar-titlebar-closeicon {\n    flex: 0 0 auto;\n    margin: 0 0.25em;\n    font-size: large;\n}\n\ndiv.sidebar div.sidebar-body {\n    overflow-y: auto;\n    overflow-x: hidden;\n    /* titlebar: 2.5em */\n    max-height: calc(100vh - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/\n    max-height: calc(var(--vh, 1vh) * 100 - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/\n    flex: 1 1 auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
